/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import BasicLayout from "../components/BasicLayout";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Button, CircularProgress } from "@mui/material";
import { adminChangePassword } from "api";

function Cover() {
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleContinue = () => {
    if (password && newPassword && confirmPassword && newPassword === confirmPassword) {
      setIsSubmitted(false);

      adminChangePasswordApi();
    } else {
      setIsSubmitted(true);
    }
  };

  const handleCancel = () => {
    navigate("/fair");
  };

  const adminChangePasswordApi = () => {
    var params = {
      password: password,
      newPassword: newPassword,
    };
    adminChangePassword({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            navigate("/authentication/admin-sign-in");
          }
        }
      })
      .catch((e) => {})
      .finally(() => {});
  };

  return (
    <DashboardLayout bgColor="info" image={bgImage}>
      <DashboardNavbar />
      <MDBox mb={2} />
      <Card
        sx={{
          width: {
            xs: "100%", // for mobile devices
            sm: "80%", // small tablets
            md: "60%", // medium screens
            lg: "50%", // large screens
          },
          mx: "left", // center the card horizontally
        }}
      >
        <MDBox p={3}>
          <MDTypography variant="h5" fontWeight="bold" mb={2}>
            Change Password
          </MDTypography>

          <MDBox gap={2} mb={2}>
            <MDBox
              component="form"
              role="form"
              onSubmit={(e) => {
                e.preventDefault();
                handleContinue(); // same as your onClick
              }}
            >
              <MDBox mb={2}>
                <MDInput
                  type="password"
                  label={
                    <>
                      Current Password
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  fullWidth
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  helperText={isSubmitted && !password ? "Current Password is required" : ""}
                  FormHelperTextProps={{
                    sx: {
                      color: "red",
                      marginLeft: "0",
                    },
                  }}
                />
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  type="password"
                  label={
                    <>
                      New Password
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  fullWidth
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  helperText={isSubmitted && !newPassword ? "New password is required" : ""}
                  FormHelperTextProps={{
                    sx: {
                      color: "red",
                      marginLeft: "0",
                    },
                  }}
                />
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  type="password"
                  label={
                    <>
                      Confirm Password
                      <span style={{ color: "red" }}>*</span>
                    </>
                  }
                  fullWidth
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  helperText={isSubmitted && !confirmPassword ? "Confirm password is required" : ""}
                  FormHelperTextProps={{
                    sx: {
                      color: "red",
                      marginLeft: "0",
                    },
                  }}
                />
              </MDBox>
              <MDBox display="flex" gap={2} mb={2} mt={4}>
                <MDButton color="secondary" fullWidth onClick={handleCancel}>
                  Cancel
                </MDButton>

                <MDButton
                  type="submit"
                  variant="gradient"
                  color="info"
                  fullWidth
                  // onClick={handleContinue}
                  disabled={isLoading}
                >
                  {isLoading ? <CircularProgress size={24} color="light" /> : "submit"}
                </MDButton>
              </MDBox>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
}

export default Cover;
